export enum EventReportGroupBy {
	Default = 0,
	Location = 1
}
